<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark py-0">
      <a class="navbar-brand" href="/">
        <img src="../../assets/logo-sm.svg" width="45" height="45" alt />
      </a>
      <button
        id="hamburger"
        @click="unfoldHamburger"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse ml-md-5 w-100" id="navbar-Nav">
        <ul class="navbar-nav w-100 d-flex justify-content-md-between">
          <li class="nav-item active px-0">
            <a class="nav-link" href="/">
              <img class src="../../assets/home.png" width="20px" alt />
              <br id="nav-break" />
              <span class style="font-size:0.8rem;">Overview</span>
            </a>
          </li>
          <li class="nav-item dropdown my-auto">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="mr-2 text-white">User Name</span>
              <img class="mr-1" src="../../assets/user-white.svg" width="25px" alt />
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" href="#" @click="logOut">
                <span class="float-left mobile-left">Log out</span>
                <span class="float-right">
                  <img class="mobile-right" src="../../assets/signout.png" width="20px" alt />
                </span>
				<div class="clear"></div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav w-100 d-md-none d-flex justify-content-md-between">
        <li class="nav-item active px-0 bg-gray">
          <a class="nav-link px-3" href="/">
            <span class="d-inline align-middle fa-nav-color" style="font-size:0.8rem;">Overview</span>
            <img class="float-right mt-1" width="20px" src="../../assets/home.svg" alt />
          </a>
        </li>
        <li class="nav-item active px-0 bg-white">
          <a class="nav-link px-3" @click="logOut" href="#">
            <span class="fa-nav-color" style="font-size:0.8rem;">Log out</span>
            <img class="float-right mt-1" width="20px" src="../../assets/signout-black.svg" alt />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  methods: {
    logOut() {
      localStorage.removeItem("jwt");
      this.$router.push("/login");
    },
    unfoldHamburger() {
      window.jQuery("#hamburger").toggleClass("folded");
    }
  }
};
</script>

<style scoped>
nav {
  background: #001d3e;
}
.navbar-dark .navbar-toggler {
  border: none;
  outline: none;
}

.nav-link:focus, .dropdown-menu:focus {
	outline: none !important;
}

#navbar-Nav .nav-item.active {
  border-top: 5px solid #0077be;
}
span#user-label {
  background: url("../../assets/user.svg") no-repeat;
}

.dropdown-menu {
  margin-top: 0.7rem !important;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='white' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
}

.navbar-toggler {
  border-color: white;
}

.folded {
}

.fa-nav-icon {
  font-size: 1.1rem;
}

.fa-nav-color {
  color: #001d3e;
}

.bg-gray {
  background: rgba(0, 29, 62, 0.2);
}

.dropdown-item {
	display:block;
}

.dropdown-item:focus, .dropdown-item:active {
	background-color: #fff;
	outline: none;
	box-shadow: none;
	color:#001d3e;
}

.clear {
	clear: both;
}

@media screen and (max-width: 768px) {
  .nav-item.active {
    border-top: none;
  }
  span.navbar-toggler-icon {
    width: 2.5em;
    height: 2.5em;
  }
  li.nav-item span {
    font-size: 1em !important;
  }
}
</style>